import { create } from 'zustand';

interface TrialState {
  isTrialRestricted: boolean;
  featureName: string | null;
  trialEndsAt: string | null;
  setTrialRestricted: (restricted: boolean, featureName?: string | null, trialEndsAt?: string | null) => void;
  clearTrialRestriction: () => void;
}

const useTrialState = create<TrialState>((set) => ({
  isTrialRestricted: false,
  featureName: null,
  trialEndsAt: null,
  setTrialRestricted: (restricted: boolean, featureName: string | null = null, trialEndsAt: string | null = null) =>
    set({ isTrialRestricted: restricted, featureName, trialEndsAt }),
  clearTrialRestriction: () =>
    set({ isTrialRestricted: false, featureName: null, trialEndsAt: null }),
}));

export default useTrialState;
